import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { onboardingHubEntryPoint } from '@atlassian/jira-onboarding-hub/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { productsOnboardingHubRoute } from '@atlassian/jira-router-routes-admin-pages-onboarding-hub-routes/src/productsOnboardingHubRoute.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';

const productsOnboardingHubEntryPoint = createPageEntryPoint({
	main: onboardingHubEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});

export const productsOnboardingHubRouteEntry = createEntry(productsOnboardingHubRoute, () => ({
	group: 'global-settings',
	entryPoint() {
		return fg('jira-onboarding-hub-gate') ? productsOnboardingHubEntryPoint : undefined;
	},
	layout: globalSettingsLayout,
	navigation: {
		menuId: MENU_ID.SETTINGS,
		sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
		sidebar: AsyncSidebarGlobalSettingsProducts,
	},
	resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
}));
